export default "__VITE_ASSET__BbAnCUaE__";